var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoldova(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f8d548",
    d: "M10 0h10v24H10z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1a43a9",
    d: "M0 24V0h10v24z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#bc2833",
    d: "M20 24V0h10v24z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#aa8160",
    d: "M18.77 15.41c-.28-1.08.76-7.64-.88-8.08-.34.2-.7.64-.83.67q.05.3.05.6c-.39 0-.78.42-1.12.47-.6-.4-.38-1.09-.32-1.63.05 0 .13.1.13.1s0-.25-.08-.3q-.01-.01.14-.03c-.03-.08-.19-.18-.19-.18q.07-.07.18-.08c-.45-.07-1.15-.65-1.5-.19-.23.02-.54.21-.47.34.3-.33 1.07.29.09 0v.05c.7.1.61 1.57.04 1.92-.34-.05-.73-.46-1.11-.47q-.01-.3.04-.6c-.13-.03-.5-.48-.83-.67-1.75.59-.46 7.14-.94 8.33.18-.07.51-.53.58-.7v.08c.28-.12.47-.45.56-.61l.01.08c.19-.16.42-.96.51-1.3l.04.06q.11.13.25.22.1.08.23.13a2 2 0 0 1-.22.37h.1l-.37.57c-.25.13-.9.23-.6.67l.03-.04c.48.88.93-.61 1.3-.9l.01.07c.06-.12.29-.32.4-.42l.35.15h.01l.1.05c-.15.34-.82 1.74-1.43 1.98-.04-.02.59.26.84.4.17-.2.59-.82.57-.81.05.08-.25.65-.42.9.38.21.85.53.98.8.14-.27.61-.59.98-.8-.16-.25-.46-.82-.42-.9-.01-.01.4.61.58.81.24-.14.87-.43.83-.4-.6-.24-1.27-1.64-1.43-1.98l.45-.2c.12.1.35.3.41.42l.01-.08c.38.3.82 1.79 1.3.9l.02.05c.31-.44-.34-.54-.59-.67-.08-.14-.34-.52-.37-.56l.1-.01a2 2 0 0 1-.22-.37q.29-.14.48-.35l.04-.07c.1.35.32 1.15.51 1.31v-.08c.1.16.3.49.57.61v-.08c.07.17.4.63.58.7 0 0-.06-.14-.06-.25"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoldova);
export default __webpack_public_path__ + "static/media/moldova.7509120e1e3f9dff6d2836bba45fb0d0.svg";
export { ForwardRef as ReactComponent };